var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 137 137",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 137,
    height: 137,
    color: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37,22.1953125 C37.4631579,18.7317708 39.3157895,17 42.5578947,17 C45.8,17 47.8842105,18.7317708 48.8105263,22.1953125 L48.8105263,40.75 L99.5263158,40.75 C101.842105,40.75 103,42.4817708 103,45.9453125 C103,49.4088542 101.842105,51.140625 99.5263158,51.140625 L48.8105263,51.140625 L48.8105263,77.1171875 C49.7368421,92.9505208 55.9894737,100.867188 67.5684211,100.867188 C79.1473684,100.867188 89.8,100.867188 99.5263158,100.867187 C101.842105,101.856771 103,103.588542 103,106.0625 C103,108.536458 101.842105,110.515625 99.5263158,112 L67.5684211,112 C47.1894737,112 37,100.372396 37,77.1171875 C37,53.8619792 37,35.5546875 37,22.1953125 Z",
    fill: "#2c2b2b",
    stroke: "#2c2b2b",
    strokeWidth: 7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotem);
export default __webpack_public_path__ + "static/media/totem.3ecef204adc04025c3656561bc9b10c6.svg";
export { ForwardRef as ReactComponent };